import { render, staticRenderFns } from "./RelocTable.vue?vue&type=template&id=1ce9044e"
import script from "./RelocTable.vue?vue&type=script&lang=ts"
export * from "./RelocTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports